import { useMediaQuery } from "@mui/material";

const useIsMobile = () => useMediaQuery("(max-width: 767px)");

export default useIsMobile;
